// House of Zena - Local Preview Title Override
(function() {
  const titleMap = {
  "ZENA-216": "The \"Caught in Orbit\" Solitaire Adjustable Ring",
  "ZENA-217": "The \"Plot Twist\" Pavé Crossover Adjustable Ring",
  "ZENA-218": "The Melted Butter Signet Adjustable Ring",
  "ZENA-219": "The Parisienne Braid Band Adjustable Ring",
  "ZENA-220": "The \"High Tide\" Pavé Ripple Adjustable Ring",
  "ZENA-221": "The Roman Column Fluted Band Adjustable Ring",
  "ZENA-222": "The \"Instant Stack\" Crossover Cage Adjustable Ring",
  "ZENA-223": "The Butter Puff Ergonomic Dome Adjustable Ring",
  "ZENA-224": "The \"Queen Bee\" Honeycomb Mosaic Adjustable Ring",
  "ZENA-225": "The Midnight Aperitivo Pavé Bangle Bracelet",
  "ZENA-226": "The \"Liquid Asset\" Sculpted Cuff Bracelet",
  "ZENA-227": "The \"Barely There\" Dewdrop Hand Chain",
  "ZENA-228": "The \"Written in the Stars\" Cascade Hand Chain",
  "ZENA-229": "The \"Less is More\" Pavé Bar Hand Chain",
  "ZENA-230": "The \"Barefoot in Goa\" Beaded Hand Chain",
  "ZENA-231": "The \"Happy Tears\" Dual Droplet Hand Chain",
  "ZENA-232": "The Maharani Rosette Pavé Hathphool Hand Chain",
  "ZENA-233": "The \"Modern Love\" Solitaire Bar Mangalsutra",
  "ZENA-234": "The \"Good Karma Only\" Nazar Mangalsutra",
  "ZENA-235": "The \"Tied the Knot\" Pavé Mangalsutra",
  "ZENA-236": "The Celestial Arch Layered Mangalsutra",
  "ZENA-237": "The Liquid Silk Herringbone Choker Necklace",
  "ZENA-238": "The \"Sunkissed in Roma\" Sunburst Medallion Necklace",
  "ZENA-239": "The Tribeca Paperclip Link Chain Necklace",
  "ZENA-240": "The Sicilian Crescent Horn Pendant Necklace",
  "ZENA-241": "The \"Follow Your North Star\" Décolletage Lariat Necklace",
  "ZENA-242": "The \"Can You Keep a Secret?\" Pavé Padlock Necklace",
  "ZENA-243": "The \"Inseparable\" Interlocking Halo Pendant Necklace",
  "ZENA-244": "The \"Heart on My Sleeve\" Sculpted Pendant Necklace",
  "ZENA-245": "The Art Deco Baguette Prism Pendant Necklace",
  "ZENA-246": "The \"Main Event\" Imperial Scallop Collar Necklace",
  "Aurelia Sculpt Hoop Earrings": "The Molten Mango Drops",
  "Liora Dual Drop Earrings": "The Minimalist Matchstick Drops",
  "Nova Star Outline Hoops": "The Lucky Star Outline Hoops",
  "Auric Wave Hoops": "The Riviera Wave Sculpted Hoops",
  "Lumière Line Drops": "The Champagne Flute Drops",
  "Élan Classic Hoops": "The Butter Croissant Hoops",
  "Solara Textured Hoops": "The Churro Ribbed Hoops",
  "Valencia Ridge Hoops": "The Roman Column Hoops",
  "Veloura Teardrop Hoops": "The Bottega Sculpted Domes",
  "Lunara Pavé Hoop Earrings": "The Sugar Rush Pavé Hoops",
  "Aurelle Double Row Huggie Earrings": "The Double Espresso Huggies",
  "Sculpté Organic Hoop Earrings": "The Melted Honeycomb Hoops",
  "Solenne Triple Charm Hoops": "The Three Wishes Charm Hoops",
  "Aurelle Geo Pavé Hoops": "The Honeycomb Pavé Huggies",
  "Celestia Link Drop Earrings": "The Manhattan Link Drop Earrings",
  "Amoura Heart Hoops": "The Sweetheart Candy Hoops",
  "Étoile Twin Heart Earrings": "The First Crush Twin Hearts",
  "Ruby Wave Ear Cuff": "The Spicy Margarita Ear Cuff",
  "Celeste Bloom Studs": "The Cherry Blossom Studs",
  "Aurielle Drop Earrings": "The Morning Dewdrop Earrings",
  "Celestia Geo Drop Earrings": "The Great Gatsby Prism Drops",
  "Azure Prism Drop Earrings": "The Blue Curacao Prism Drops",
  "Blush Halo Huggie Earrings": "The Strawberry Milk Huggies",
  "Amethyst Swirl Huggie Earrings": "The Lavender Swirl Huggies",
  "Celeste Evil Eye Drop Earrings": "The Side-Eye Charm Drops",
  "Blush Link Drop Earrings": "The Pink Lemonade Link Drops",
  "Ivory Link Drop Earrings": "The Vanilla Bean Link Drops",
  "Luna Pearl Curve Hoops": "The Oyster Pearl Crescent Hoops",
  "Luna Noir Curve Hoops": "The Black Sesame Crescent Hoops",
  "Starlit Wave Huggie Earrings": "The Ocean Ripple Huggies",
  "Auric Wave Crystal Huggies": "The Golden Nugget Huggies",
  "Palm Aura Crystal Hoops": "The Coconut Tree Resort Hoops",
  "Noir Prism Drop Earrings": "The Dark Chocolate Prism Drops",
  "Ivory Prism Drop Earrings": "The Coconut Milk Prism Drops",
  "Silver Prism Luxe Drops": "The Diamond Dust Prism Drops",
  "Dual Curve Pavé Hoops": "The Crisscross Pavé Illusion Hoops",
  "Luna Prism Drop Earrings": "The Midnight Aperitivo Prism Drops",
  "Halo Orbit Earrings": "The Floating Orbit Sphere Drops",
  "Azure Glow Hoops": "The Capri Blue Mini Hoops",
  "Celeste Halo Drops": "The Happy Tears Solitaire Drops",
  "Emerald Edge Hoops": "The Mint Mojito Edge Hoops",
  "Violet Edge Hoops": "The Wild Grape Edge Hoops",
  "Luna Curve Studs": "The Fortune Cookie Studs",
  "Nova Grid Huggies": "The Waffle Grid Chunky Huggies",
  "Blush Pop Hoops": "The Bubblegum Pop Hoops",
  "Blush Bamboo Hoops": "The Rose Quartz Bamboo Hoops",
  "Lavender Bamboo Hoops": "The Taro Milk Bamboo Hoops",
  "Olive Bamboo Hoops": "The Olive Martini Bamboo Hoops",
  "Matcha Bamboo Hoops": "The Matcha Latte Bamboo Hoops",
  "Emerald Drop Huggies": "The Green Apple Mini Huggies",
  "Sunbeam Drop Huggies": "The Sunny Lemon Mini Huggies",
  "Lilac Drop Huggies": "The Wild Lavender Mini Huggies",
  "Midnight Prism Hoops": "The Espresso Smoke Prism Hoops",
  "Noir Eclipse Studs": "The Total Eclipse Studs",
  "Noir Eclipse Hoops": "The \"Dark Mode\" Chunky Hoops",
  "Emerald Noir Hoops": "The Pistachio Truffle Hoops",
  "Shadow Edge Hoops": "The Tuxedo Edge Hoops",
  "Twilight Twist Hoops": "The Licorice Twist Hoops",
  "Éclat Baguette Tennis Bracelet": "The Ice Cube Tennis Bracelet",
  "Luna Classic Tennis Bracelet": "The Espresso Shot Tennis Bracelet",
  "Celeste Princess Tennis Bracelet": "The Sugar Cube Tennis Bracelet",
  "Auric Pavé Cuban Bracelet": "The \"Main Character\" Cuban Chain",
  "Valora Pavé Cuban Bracelet": "The Espresso Martini Cuban",
  "Aurelia Link Bracelet": "The 9-to-5 Paperclip Chain (Gold)",
  "Noiré Link Bracelet": "The 9-to-5 Paperclip Chain (Silver)",
  "Sorelle Pavé Cuban Bracelet": "The \"Rich Auntie\" Pavé Chain",
  "Évora Crystal Link Bracelet": "The Chocolate Bar Link Bracelet",
  "Solène Luxe Tennis Bracelet": "The Double Shot Tennis Bracelet",
  "Seraphine Twist Bracelet": "The French Churro Rope Chain",
  "Astera Greek Link Bracelet": "The Spartan Key Link Chain",
  "Celestia Halo Bracelet": "The Sunny Side Up Halo Chain",
  "Virelle Chevron Bracelet": "The St. Tropez Chevron Tennis",
  "Aveline Princess Tennis Bracelet": "The Iceberg Princess Tennis",
  "Lunara Pavé Link Bracelet": "The Yacht Club Anchor Bracelet",
  "Elaria Marquise Charm Bracelet": "The Olive Branch Charm Bracelet",
  "Celestia Bloom Bracelet": "The Wild Daisy Chain Bracelet",
  "Aureline Link Bracelet": "The Café Au Lait Puff Link",
  "Lunara Bar Bracelet": "The \"Out of Office\" Bar Bracelet",
  "Aureline Toggle Bracelet": "The \"Locked & Loaded\" Toggle",
  "Celestia Prism Bracelet": "The Disco Ball Prism Bracelet",
  "Luna Nazar Bracelet": "The \"Side-Eye\" Nazar Bracelet",
  "Aurielle Tennis Bracelet": "The Met Gala Tennis Bracelet",
  "Vesper Grid Bracelet": "The Milanese Woven Grid Chain",
  "Luna Line Tennis Bracelet": "The \"Skinny Dip\" Tennis Bracelet",
  "Celeste Halo Bracelet": "The Stargazer Halo Chain",
  "Monarch Grid Bracelet": "The Boardroom Siren Grid Chain",
  "Stellar Orbit Bracelet": "The Celestial Orbit Station Chain",
  "Aurora Medallion Bracelet": "The Golden Hour Coin Bracelet",
  "Infinity Grace Bracelet": "The \"Pinky Promise\" Infinity Chain",
  "Lockline Cuban Bracelet": "The Secret Keeper Padlock Chain",
  "Maze Pop Bracelet Collection": "The Mykonos Blue Maze Cuff",
  "Lagoon Tennis Bracelet": "The Swimming Pool Tennis Bracelet",
  "Celestia Bloom Pendant Set": "The Sweet Jasmine Garden Set",
  "Lunéa Halo Pendant Set": "The Sunny Side Up Solitaire Set",
  "Élan Bar Pendant Set": "The \"Minimal Effort\" Bar Set",
  "Serelune Spiral Pendant Set": "The Cinnamon Roll Spiral Set",
  "Asterelle Bloom Pendant Set": "The Lotus Petal Brunch Set",
  "Veloura Wave Pendant Set": "The Melted Honeycomb Set",
  "Aureline Halo Pendant Set": "The \"Main Character\" Crown Set",
  "Lunéa Link Pendant Set": "The 9-to-5 Office Chic Set",
  "Évara Drop Pendant Set": "The Happy Tears Solitaire Set",
  "Seréna Drop Pendant Set": "The Waterfall Martini Set",
  "Nazira Evil Eye Pendant Set": "The \"No Drama\" Nazar Set",
  "Avelisse Cascade Pendant Set": "The Champagne Tower Cascade Set",
  "Celestine Edge Pendant Set": "The Modernist Frame Solitaire Set",
  "Lunara Link Pendant Set": "The \"You & Me\" Interlock Set",
  "Aurelia Bloom Pendant Set": "The Sunflower Sunshine Set",
  "Nova Triangle Pendant Set": "The Art Deco Geometric Set",
  "Elara Drop Pendant Set": "The \"I Woke Up Like This\" Set",
  "Virelle Square Pendant Set": "The Sugar Cube Solitaire Set",
  "Nazira Hamsa Pendant Set": "The \"Good Karma Only\" Hamsa Set",
  "Celestia Geometric Pendant Set": "The Great Gatsby Cocktail Set",
  "Lunara Oval Pendant Set": "The Almond Truffle Solitaire Set",
  "Infinity Grace Pendant Set": "The \"Pinky Promise\" Infinity Set",
  "Noir Halo Pendant Set": "The Black Truffle Midnight Set",
  "Aurora Wave Pendant Set": "The Golden Hour Ripple Set",
  "Luna Glow Pendant Set": "The Mooncake Pearl Glow Set",
  "Dewdrop Elegance Pendant Set": "The Morning Dewdrop Set",
  "Eterna Loop Pendant Set": "The Mobius Knot Eternal Set",
  "Astra Edge Pendant Set": "The Old Money Emerald-Cut Set",
  "Noor Hamsa Pendant Set": "The \"Holy Grail\" Protection Set",
  "Rouge Luxe Charm Pendant Set": "The Red Velvet Romance Set",
  "Halo Wire Bangle": "The \"Sleep in It\" Wire Bangle",
  "Rouge Line Bangle": "The Cherry Syrup Line Bangle",
  "Celeste Orbit Bangle": "The Celestial Orbit Open Cuff",
  "Auric Maze Bangle": "The Labyrinth Gold Cuff",
  "Luna Marquise Bangle": "The Olive Leaf Open Cuff",
  "Lumière Lock Bangle": "The \"Locked In\" Hinge Bangle",
  "Éclat Prism Bangle": "The Diamond Cut Mirror Bangle",
  "Aurielle Linea Bangle": "The Golden Highway Pavé Bangle",
  "Celestia Pavé Bangle": "The Sparkling Donut Bangle",
  "Aurelia Halo Bangle": "The Queen Bee Crown Bangle",
  "Lunéa Link Bangle": "The Paperclip Stacking Cuff",
  "Valencia Studded Bangle": "The Rock & Roll Studded Bangle",
  "Orlena Royale Bangle": "The Cleopatra Royal Filigree Cuff",
  "Étoile Frame Bangle": "The Architectural Frame Bangle",
  "Celestelle Bar Bangle": "The Minimalist Horizon Bar Cuff",
  "Élan Duo Clover Bangle": "The Lucky Four-Leaf Clover Bangle",
  "Aurielle Infinity Twist Bangle": "The French Cruller Twist Bangle",
  "Aurelia Studline Bangle": "The Caviar Bead Bangle",
  "Celeste Linea Bangle": "The Date Night Solitaire Bangle",
  "Valenza Chevron Pavé Bangle": "The Wishbone Chevron Bangle",
  "Étoile Ribbon Pavé Bangle": "The Silk Ribbon Pavé Bangle",
  "Celestia Twist Tennis Bangle": "The Croissant Tennis Bangle",
  "Luné Wave Bangle": "The Melted Butter Wave Bangle",
  "Éclat Slim Pavé Bangle": "The Skinny Dip Stacking Bangle",
  "Aurielle Linear Pavé Bangle": "The Fast Track Triple Bangle",
  "Elowen Infinity Bangle": "The \"Forever Yours\" Infinity Bangle",
  "Astra Curve Bangle": "The Liquid Gold Contour Cuff",
  "Veya Twist Pavé Bangle": "The \"Kiss Me\" Crisscross Bangle",
  "Éterne Link Pavé Bangle": "The Chain Reaction Pavé Bangle",
  "Linéa Wave Pavé Bangle": "The High Tide Ripple Bangle",
  "Astra Parallel Pavé Bangle": "The Dual Lineage Pavé Cuff",
  "Élan Full Pavé Curve Bangle": "The Drama Queen Sculpted Bangle",
  "Amora Open Heart Necklace": "The \"Wear Your Heart\" Floating Pendant",
  "Rouge Duo Pendant Necklace": "The Cherry Duo Solitaire Pendant",
  "Luna Lock Evil Eye Necklace": "The \"Mind Your Business\" Padlock",
  "Celestia Charm Drop Necklace": "The Midnight Stargazer Y-Lariat",
  "Aurielle Gradient Heart Necklace": "The Watermelon Sugar Heart Pendant",
  "Lunara Crescent Necklace": "The Italian Croissant Horn Pendant",
  "Noir Nazar Charm Necklace": "The \"Bad Vibes Deflector\" Medallion",
  "Solara Cross Medallion Necklace": "The Sunday Brunch Cross Medallion",
  "Luna Wave Jewellery Set\nIncludes\nPendant Necklace\nStatement Bracelet\nMatching Stud Earrings": "The \"Rich Auntie\" 3-Piece Power Set",
  "Luna Wave Jewellery Set Includes Pendant Necklace Statement Bracelet Matching Stud Earrings": "The \"Rich Auntie\" 3-Piece Power Set",
  "Monarch Link Jewellery Set\nIncludes\nPendant Necklace\nStatement Bracelet\nMatching Earrings": "The \"Boardroom Boss\" 3-Piece Power Set",
  "Monarch Link Jewellery Set Includes Pendant Necklace Statement Bracelet Matching Earrings": "The \"Boardroom Boss\" 3-Piece Power Set",
  "Nova Grid Jewellery Set\nIncludes\nPendant Necklace\nStatement Bracelet\nMatching Earrings": "The \"Out of Office\" 3-Piece Power Set",
  "Nova Grid Jewellery Set Includes Pendant Necklace Statement Bracelet Matching Earrings": "The \"Out of Office\" 3-Piece Power Set",
  "Celeste Wave Ear Cuff": "The High Tide Slip-On Cuff",
  "Luna Spark Ear Cuff": "The Firefly Ear Cuff",
  "Aurielle Bow Ear Cuff": "The Coquette Bow Ear Cuff",
  "Celestia Triple Layer Ear Cuff": "The Triple Decker Stacking Cuff",
  "Noir Blaze Brooch": "The Dragon Fire Onyx Brooch",
  "Celeste Gecko Brooch": "The Mediterranean Lizard Emerald Brooch",
  "Auric Gecko Brooch": "The Imperial Crystal Lizard Brooch",
  "Stellar Anchor Brooch": "The Captain's Anchor Sailor Brooch",
  "Golden Laurel Brooch": "The Victory Crown Laurel Pin",
  "Celestia Bloom Brooch": "The Camellia Flower Lapel Pin",
  "Azure Crest Pearl Brooch": "The Royal Crest Baroque Brooch",
  "Aurora Flamingo Brooch": "The Miami Flamingo Statement Brooch",
  "Celestia Star Anklet": "The \"Barefoot in Bali\" Star Anklet",
  "Luna Nazar Anklet": "The \"Watch Your Step\" Nazar Anklet",
  "The \"Queen Bee\" Honeycomb Mosaic Ring": "The \"Queen Bee\" Honeycomb Mosaic Adjustable Ring",
  "The Butter Puff Ergonomic Dome Ring": "The Butter Puff Ergonomic Dome Adjustable Ring",
  "The \"Instant Stack\" Crossover Cage Ring": "The \"Instant Stack\" Crossover Cage Adjustable Ring",
  "The Roman Column Fluted Band Ring": "The Roman Column Fluted Band Adjustable Ring",
  "The \"High Tide\" Pavé Ripple Ring": "The \"High Tide\" Pavé Ripple Adjustable Ring",
  "The Parisienne Braid Band Ring": "The Parisienne Braid Band Adjustable Ring",
  "The Melted Butter Signet Ring": "The Melted Butter Signet Adjustable Ring",
  "The \"Plot Twist\" Pavé Crossover Ring": "The \"Plot Twist\" Pavé Crossover Adjustable Ring",
  "The \"Caught in Orbit\" Solitaire Ring": "The \"Caught in Orbit\" Solitaire Adjustable Ring"
};
  const handleMap = {
  "aurelia-sculpt-hoop-earrings": "The Molten Mango Drops",
  "liora-dual-drop-earrings": "The Minimalist Matchstick Drops",
  "nova-star-outline-hoops": "The Lucky Star Outline Hoops",
  "auric-wave-hoops": "The Riviera Wave Sculpted Hoops",
  "lumiere-line-drops": "The Champagne Flute Drops",
  "elan-classic-hoops": "The Butter Croissant Hoops",
  "solara-textured-hoops": "The Churro Ribbed Hoops",
  "valencia-ridge-hoops": "The Roman Column Hoops",
  "veloura-teardrop-hoops": "The Bottega Sculpted Domes",
  "lunara-pave-hoop-earrings": "The Sugar Rush Pavé Hoops",
  "aurelle-double-row-huggie-earrings": "The Double Espresso Huggies",
  "sculpte-organic-hoop-earrings": "The Melted Honeycomb Hoops",
  "solenne-triple-charm-hoops": "The Three Wishes Charm Hoops",
  "aurelle-geo-pave-hoops": "The Honeycomb Pavé Huggies",
  "celestia-link-drop-earrings": "The Manhattan Link Drop Earrings",
  "amoura-heart-hoops": "The Sweetheart Candy Hoops",
  "etoile-twin-heart-earrings": "The First Crush Twin Hearts",
  "ruby-wave-ear-cuff": "The Spicy Margarita Ear Cuff",
  "celeste-bloom-studs": "The Cherry Blossom Studs",
  "aurielle-drop-earrings": "The Morning Dewdrop Earrings",
  "celestia-geo-drop-earrings": "The Great Gatsby Prism Drops",
  "azure-prism-drop-earrings": "The Blue Curacao Prism Drops",
  "blush-halo-huggie-earrings": "The Strawberry Milk Huggies",
  "amethyst-swirl-huggie-earrings": "The Lavender Swirl Huggies",
  "celeste-evil-eye-drop-earrings": "The Side-Eye Charm Drops",
  "blush-link-drop-earrings": "The Pink Lemonade Link Drops",
  "ivory-link-drop-earrings": "The Vanilla Bean Link Drops",
  "luna-pearl-curve-hoops": "The Oyster Pearl Crescent Hoops",
  "luna-noir-curve-hoops": "The Black Sesame Crescent Hoops",
  "starlit-wave-huggie-earrings": "The Ocean Ripple Huggies",
  "auric-wave-crystal-huggies": "The Golden Nugget Huggies",
  "palm-aura-crystal-hoops": "The Coconut Tree Resort Hoops",
  "noir-prism-drop-earrings": "The Dark Chocolate Prism Drops",
  "ivory-prism-drop-earrings": "The Coconut Milk Prism Drops",
  "silver-prism-luxe-drops": "The Diamond Dust Prism Drops",
  "dual-curve-pave-hoops": "The Crisscross Pavé Illusion Hoops",
  "luna-prism-drop-earrings": "The Midnight Aperitivo Prism Drops",
  "halo-orbit-earrings": "The Floating Orbit Sphere Drops",
  "azure-glow-hoops": "The Capri Blue Mini Hoops",
  "celeste-halo-drops": "The Happy Tears Solitaire Drops",
  "emerald-edge-hoops": "The Mint Mojito Edge Hoops",
  "violet-edge-hoops": "The Wild Grape Edge Hoops",
  "luna-curve-studs": "The Fortune Cookie Studs",
  "nova-grid-huggies": "The Waffle Grid Chunky Huggies",
  "blush-pop-hoops": "The Bubblegum Pop Hoops",
  "blush-bamboo-hoops": "The Rose Quartz Bamboo Hoops",
  "lavender-bamboo-hoops": "The Taro Milk Bamboo Hoops",
  "olive-bamboo-hoops": "The Olive Martini Bamboo Hoops",
  "matcha-bamboo-hoops": "The Matcha Latte Bamboo Hoops",
  "emerald-drop-huggies": "The Green Apple Mini Huggies",
  "sunbeam-drop-huggies": "The Sunny Lemon Mini Huggies",
  "lilac-drop-huggies": "The Wild Lavender Mini Huggies",
  "midnight-prism-hoops": "The Espresso Smoke Prism Hoops",
  "noir-eclipse-studs": "The Total Eclipse Studs",
  "noir-eclipse-hoops": "The \"Dark Mode\" Chunky Hoops",
  "emerald-noir-hoops": "The Pistachio Truffle Hoops",
  "shadow-edge-hoops": "The Tuxedo Edge Hoops",
  "twilight-twist-hoops": "The Licorice Twist Hoops",
  "eclat-baguette-tennis-bracelet": "The Ice Cube Tennis Bracelet",
  "luna-classic-tennis-bracelet": "The Espresso Shot Tennis Bracelet",
  "celeste-princess-tennis-bracelet": "The Sugar Cube Tennis Bracelet",
  "auric-pave-cuban-bracelet": "The \"Main Character\" Cuban Chain",
  "valora-pave-cuban-bracelet": "The Espresso Martini Cuban",
  "aurelia-link-bracelet": "The 9-to-5 Paperclip Chain (Gold)",
  "noire-link-bracelet": "The 9-to-5 Paperclip Chain (Silver)",
  "sorelle-pave-cuban-bracelet": "The \"Rich Auntie\" Pavé Chain",
  "evora-crystal-link-bracelet": "The Chocolate Bar Link Bracelet",
  "solene-luxe-tennis-bracelet": "The Double Shot Tennis Bracelet",
  "seraphine-twist-bracelet": "The French Churro Rope Chain",
  "astera-greek-link-bracelet": "The Spartan Key Link Chain",
  "celestia-halo-bracelet": "The Sunny Side Up Halo Chain",
  "virelle-chevron-bracelet": "The St. Tropez Chevron Tennis",
  "aveline-princess-tennis-bracelet": "The Iceberg Princess Tennis",
  "lunara-pave-link-bracelet": "The Yacht Club Anchor Bracelet",
  "elaria-marquise-charm-bracelet": "The Olive Branch Charm Bracelet",
  "celestia-bloom-bracelet": "The Wild Daisy Chain Bracelet",
  "aureline-link-bracelet": "The Café Au Lait Puff Link",
  "lunara-bar-bracelet": "The \"Out of Office\" Bar Bracelet",
  "aureline-toggle-bracelet": "The \"Locked & Loaded\" Toggle",
  "celestia-prism-bracelet": "The Disco Ball Prism Bracelet",
  "luna-nazar-bracelet": "The \"Side-Eye\" Nazar Bracelet",
  "aurielle-tennis-bracelet": "The Met Gala Tennis Bracelet",
  "vesper-grid-bracelet": "The Milanese Woven Grid Chain",
  "luna-line-tennis-bracelet": "The \"Skinny Dip\" Tennis Bracelet",
  "celeste-halo-bracelet": "The Stargazer Halo Chain",
  "monarch-grid-bracelet": "The Boardroom Siren Grid Chain",
  "stellar-orbit-bracelet": "The Celestial Orbit Station Chain",
  "aurora-medallion-bracelet": "The Golden Hour Coin Bracelet",
  "infinity-grace-bracelet": "The \"Pinky Promise\" Infinity Chain",
  "lockline-cuban-bracelet": "The Secret Keeper Padlock Chain",
  "maze-pop-bracelet-collection": "The Mykonos Blue Maze Cuff",
  "lagoon-tennis-bracelet": "The Swimming Pool Tennis Bracelet",
  "celestia-bloom-pendant-set-34": "The Morning Bloom Coffee & Cake Set",
  "lunea-halo-pendant-set": "The Sunny Side Up Solitaire Set",
  "elan-bar-pendant-set": "The \"Minimal Effort\" Bar Set",
  "serelune-spiral-pendant-set": "The Cinnamon Roll Spiral Set",
  "asterelle-bloom-pendant-set": "The Lotus Petal Brunch Set",
  "veloura-wave-pendant-set": "The Melted Honeycomb Set",
  "aureline-halo-pendant-set": "The \"Main Character\" Crown Set",
  "lunea-link-pendant-set": "The 9-to-5 Office Chic Set",
  "evara-drop-pendant-set": "The Happy Tears Solitaire Set",
  "celestia-bloom-pendant-set-43": "The Sweet Jasmine Garden Set",
  "serena-drop-pendant-set": "The Waterfall Martini Set",
  "nazira-evil-eye-pendant-set": "The \"No Drama\" Nazar Set",
  "avelisse-cascade-pendant-set": "The Champagne Tower Cascade Set",
  "celestine-edge-pendant-set": "The Modernist Frame Solitaire Set",
  "lunara-link-pendant-set": "The \"You & Me\" Interlock Set",
  "aurelia-bloom-pendant-set": "The Sunflower Sunshine Set",
  "nova-triangle-pendant-set": "The Art Deco Geometric Set",
  "elara-drop-pendant-set": "The \"I Woke Up Like This\" Set",
  "virelle-square-pendant-set": "The Sugar Cube Solitaire Set",
  "nazira-hamsa-pendant-set": "The \"Good Karma Only\" Hamsa Set",
  "celestia-geometric-pendant-set": "The Great Gatsby Cocktail Set",
  "lunara-oval-pendant-set": "The Almond Truffle Solitaire Set",
  "infinity-grace-pendant-set": "The \"Pinky Promise\" Infinity Set",
  "noir-halo-pendant-set": "The Black Truffle Midnight Set",
  "aurora-wave-pendant-set": "The Golden Hour Ripple Set",
  "luna-glow-pendant-set": "The Mooncake Pearl Glow Set",
  "dewdrop-elegance-pendant-set": "The Morning Dewdrop Set",
  "eterna-loop-pendant-set": "The Mobius Knot Eternal Set",
  "astra-edge-pendant-set": "The Old Money Emerald-Cut Set",
  "noor-hamsa-pendant-set": "The \"Holy Grail\" Protection Set",
  "rouge-luxe-charm-pendant-set": "The Red Velvet Romance Set",
  "halo-wire-bangle": "The \"Sleep in It\" Wire Bangle",
  "rouge-line-bangle": "The Cherry Syrup Line Bangle",
  "celeste-orbit-bangle": "The Celestial Orbit Open Cuff",
  "auric-maze-bangle": "The Labyrinth Gold Cuff",
  "luna-marquise-bangle": "The Olive Leaf Open Cuff",
  "lumiere-lock-bangle": "The \"Locked In\" Hinge Bangle",
  "eclat-prism-bangle": "The Diamond Cut Mirror Bangle",
  "aurielle-linea-bangle": "The Golden Highway Pavé Bangle",
  "celestia-pave-bangle": "The Sparkling Donut Bangle",
  "aurelia-halo-bangle": "The Queen Bee Crown Bangle",
  "lunea-link-bangle": "The Paperclip Stacking Cuff",
  "valencia-studded-bangle": "The Rock & Roll Studded Bangle",
  "orlena-royale-bangle": "The Cleopatra Royal Filigree Cuff",
  "etoile-frame-bangle": "The Architectural Frame Bangle",
  "celestelle-bar-bangle": "The Minimalist Horizon Bar Cuff",
  "elan-duo-clover-bangle": "The Lucky Four-Leaf Clover Bangle",
  "aurielle-infinity-twist-bangle": "The French Cruller Twist Bangle",
  "aurelia-studline-bangle": "The Caviar Bead Bangle",
  "celeste-linea-bangle": "The Date Night Solitaire Bangle",
  "valenza-chevron-pave-bangle": "The Wishbone Chevron Bangle",
  "etoile-ribbon-pave-bangle": "The Silk Ribbon Pavé Bangle",
  "celestia-twist-tennis-bangle": "The Croissant Tennis Bangle",
  "lune-wave-bangle": "The Melted Butter Wave Bangle",
  "eclat-slim-pave-bangle": "The Skinny Dip Stacking Bangle",
  "aurielle-linear-pave-bangle": "The Fast Track Triple Bangle",
  "elowen-infinity-bangle": "The \"Forever Yours\" Infinity Bangle",
  "astra-curve-bangle": "The Liquid Gold Contour Cuff",
  "veya-twist-pave-bangle": "The \"Kiss Me\" Crisscross Bangle",
  "eterne-link-pave-bangle": "The Chain Reaction Pavé Bangle",
  "linea-wave-pave-bangle": "The High Tide Ripple Bangle",
  "astra-parallel-pave-bangle": "The Dual Lineage Pavé Cuff",
  "elan-full-pave-curve-bangle": "The Drama Queen Sculpted Bangle",
  "amora-open-heart-necklace": "The \"Wear Your Heart\" Floating Pendant",
  "rouge-duo-pendant-necklace": "The Cherry Duo Solitaire Pendant",
  "luna-lock-evil-eye-necklace": "The \"Mind Your Business\" Padlock",
  "celestia-charm-drop-necklace": "The Midnight Stargazer Y-Lariat",
  "aurielle-gradient-heart-necklace": "The Watermelon Sugar Heart Pendant",
  "lunara-crescent-necklace": "The Italian Croissant Horn Pendant",
  "noir-nazar-charm-necklace": "The \"Bad Vibes Deflector\" Medallion",
  "solara-cross-medallion-necklace": "The Sunday Brunch Cross Medallion",
  "luna-wave-jewellery-set-includes-pendant-necklace-statement-bracelet-matching-stud-earrings": "The \"Rich Auntie\" 3-Piece Power Set",
  "monarch-link-jewellery-set-includes-pendant-necklace-statement-bracelet-matching-earrings": "The \"Boardroom Boss\" 3-Piece Power Set",
  "nova-grid-jewellery-set-includes-pendant-necklace-statement-bracelet-matching-earrings": "The \"Out of Office\" 3-Piece Power Set",
  "celeste-wave-ear-cuff": "The High Tide Slip-On Cuff",
  "luna-spark-ear-cuff": "The Firefly Ear Cuff",
  "aurielle-bow-ear-cuff": "The Coquette Bow Ear Cuff",
  "celestia-triple-layer-ear-cuff": "The Triple Decker Stacking Cuff",
  "noir-blaze-brooch": "The Dragon Fire Onyx Brooch",
  "celeste-gecko-brooch": "The Mediterranean Lizard Emerald Brooch",
  "auric-gecko-brooch": "The Imperial Crystal Lizard Brooch",
  "stellar-anchor-brooch": "The Captain's Anchor Sailor Brooch",
  "golden-laurel-brooch": "The Victory Crown Laurel Pin",
  "celestia-bloom-brooch": "The Camellia Flower Lapel Pin",
  "azure-crest-pearl-brooch": "The Royal Crest Baroque Brooch",
  "aurora-flamingo-brooch": "The Miami Flamingo Statement Brooch",
  "celestia-star-anklet": "The \"Barefoot in Bali\" Star Anklet",
  "luna-nazar-anklet": "The \"Watch Your Step\" Nazar Anklet",
  "the-queen-bee-honeycomb-mosaic-ring": "The \"Queen Bee\" Honeycomb Mosaic Adjustable Ring",
  "the-butter-puff-ergonomic-dome-ring": "The Butter Puff Ergonomic Dome Adjustable Ring",
  "the-instant-stack-crossover-cage-ring": "The \"Instant Stack\" Crossover Cage Adjustable Ring",
  "the-roman-column-fluted-band-ring": "The Roman Column Fluted Band Adjustable Ring",
  "the-high-tide-pave-ripple-ring": "The \"High Tide\" Pavé Ripple Adjustable Ring",
  "the-parisienne-braid-band-ring": "The Parisienne Braid Band Adjustable Ring",
  "the-melted-butter-signet-ring": "The Melted Butter Signet Adjustable Ring",
  "the-plot-twist-pave-crossover-ring": "The \"Plot Twist\" Pavé Crossover Adjustable Ring",
  "the-caught-in-orbit-solitaire-ring": "The \"Caught in Orbit\" Solitaire Adjustable Ring"
};

  // Build normalized accent-insensitive mapping for 100% resilient lookup
  const normalizedTitleMap = {};
  function normalizeStr(str) {
    return (str || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-zA-Z0-9\s]/g, '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  for (const key in titleMap) {
    normalizedTitleMap[normalizeStr(key)] = titleMap[key];
  }

  function getNewTitle(oldTitle, href) {
    if (!oldTitle && !href) return null;
    
    // 1. Direct exact or trimmed match in titleMap
    if (oldTitle) {
      const cleanOld = oldTitle.replace(/\s+/g, ' ').trim();
      if (titleMap[cleanOld]) return titleMap[cleanOld];
      
      // 2. Normalized match (handles French accents è/é, punctuation, quotes)
      const norm = normalizeStr(cleanOld);
      if (normalizedTitleMap[norm]) return normalizedTitleMap[norm];

      // 3. Substring key match
      for (const key in titleMap) {
        if (cleanOld.toLowerCase() === key.toLowerCase()) {
          return titleMap[key];
        }
      }
    }
    
    // 4. Check handle from URL / pathname / dataset if available
    const targetHref = href || (window.location.pathname.includes('/products/') ? window.location.pathname : '');
    if (targetHref) {
      const match = targetHref.match(/\/products\/([^/?#]+)/);
      if (match && handleMap[match[1]]) {
        return handleMap[match[1]];
      }
    }
    return null;
  }

  // Expose global title lookup function
  window.getZenaProductTitle = getNewTitle;
  window.zenaTitleMap = titleMap;
  window.zenaHandleMap = handleMap;

  let isTabInactive = false;
  let savedActiveTitle = document.title || 'Everyday Demi-Fine Collection – House of Zena';

  function replaceTitles() {
    // 1. Product card titles (Grid, Featured, Swipers, Budget, Top Styles, Best Sellers, One Day Five Ways, Reviews, Gifting)
    document.querySelectorAll('.product-card-title, .product-card .card-title, h3.product-card-title, .product-card-title a, .product-card a.stretched-link, .product-card h2, .product-card h3, .card-product-title, .product-title-link, .zena-odfw-item-title, .zena-zr-product-title, .zena-zg-item-title, .zena-ts-card-title, .zena-ts-title, .zena-sbb-item-title, .zena-sbb-title, .zena-sbb-title a, .zena-sbb-product-card h3, .zena-bs-title, .zena-bs-card-title, .zena-bs-card-title a, .cross-sells-title, .zena-cross-sell-item-title, .zena-fbt-item-title, .collection-product-title').forEach(el => {
      const parentLink = el.closest('a') || el.querySelector('a') || (el.closest('.product-card, .zena-odfw-item-card, .zena-zr-card, .zena-zg-item-card, .zena-sbb-product-card, .zena-ts-product-card, .zena-bs-card, .cross-sells') ? el.closest('.product-card, .zena-odfw-item-card, .zena-zr-card, .zena-zg-item-card, .zena-sbb-product-card, .zena-ts-product-card, .zena-bs-card, .cross-sells').querySelector('a[href*="/products/"]') : null);
      const href = parentLink ? parentLink.getAttribute('href') : (el.dataset.productHandle ? `/products/${el.dataset.productHandle}` : null);
      const newTitle = getNewTitle(el.textContent, href);
      if (newTitle) {
        const target = (el.tagName === 'A') ? el : (el.querySelector('a') || el);
        if (target.textContent.trim() !== newTitle) {
          target.textContent = newTitle;
        }
      }
    });

    // 2. Product main detail page title (PDP) & Quick View
    document.querySelectorAll('h1.product-title, .product-title, .product-main h1, .product-title-wrapper h1, h1[data-product-title], span[data-product-title], #quick-view-modal h1, #quick-view-modal .product-title, .quick-view-contents h1').forEach(el => {
      const newTitle = getNewTitle(el.textContent, window.location.pathname);
      if (newTitle && el.textContent.trim() !== newTitle) {
        el.textContent = newTitle;
      }
    });

    // 2b. Sticky Bottom ATC Bar (PDP & Floating Bars)
    document.querySelectorAll('.sticky-atc-title, .sticky-atc-title a, .sticky-atc h3, .sticky-atc-info h3, .sticky-atc-left h3, sticky-atc h3, sticky-atc .text-truncate, .sticky-media-caption-title, .sticky-media h3').forEach(el => {
      const href = el.dataset.productHandle ? `/products/${el.dataset.productHandle}` : window.location.pathname;
      const newTitle = getNewTitle(el.textContent, href);
      if (newTitle && el.textContent.trim() !== newTitle) {
        el.textContent = newTitle;
      }
    });

    // 3. Document Title / Tab title (ONLY when tab is active!)
    if (!isTabInactive && !document.hidden) {
      if (window.location.pathname.includes('/products/')) {
        const match = window.location.pathname.match(/\/products\/([^/?#]+)/);
        if (match && handleMap[match[1]]) {
          const brand = ' – Zena';
          const expectedTitle = handleMap[match[1]] + brand;
          if (document.title !== expectedTitle) {
            document.title = expectedTitle;
            savedActiveTitle = expectedTitle;
          }
        }
      } else {
        if (!document.title.includes('✨') && !document.title.includes('❤️')) {
          savedActiveTitle = document.title;
        }
      }
    }

    // 4. Cart items, offcanvas drawer, upsells, wishlist, predictive search
    document.querySelectorAll('.cart-item-product-title, .cart-item-product-title a, .cart-item-title, .cart-item h3, .offcanvas-cart h3, .offcanvas-cart .title, .cart-upsells-item h3, .wishlist-item h3, .wishlist-item-title, .cart-drawer-item-title, .predictive-search-item h3, .zena-search-product-title, .search-product-title').forEach(el => {
      const link = el.closest('a') || el.querySelector('a') || (el.closest('.cart-item') ? el.closest('.cart-item').querySelector('a[href*="/products/"]') : null);
      const href = link ? link.getAttribute('href') : null;
      const newTitle = getNewTitle(el.textContent, href);
      if (newTitle) {
        const target = (el.tagName === 'A') ? el : (el.querySelector('a') || el);
        if (target.textContent.trim() !== newTitle) {
          target.textContent = newTitle;
        }
      }
    });

    // 5. Breadcrumb links
    document.querySelectorAll('.breadcrumb-item, .breadcrumb').forEach(el => {
      const activeItem = el.querySelector('.active') || (el.classList.contains('active') ? el : null);
      if (activeItem) {
        const newTitle = getNewTitle(activeItem.textContent, window.location.pathname);
        if (newTitle && activeItem.textContent.trim() !== newTitle) {
          activeItem.textContent = newTitle;
        }
      }
    });

    // 6. Product Images (img elements in cards, galleries, cart thumbs, search)
    document.querySelectorAll('img[alt], .product-card img, .product-main img, .cart-item img, .zena-search-product-thumb img, .product-media-item img, .sticky-atc img').forEach(img => {
      const alt = img.getAttribute('alt') || '';
      const parentLink = img.closest('a') || (img.closest('.product-card') ? img.closest('.product-card').querySelector('a[href*="/products/"]') : null) || (img.closest('.cart-item') ? img.closest('.cart-item').querySelector('a[href*="/products/"]') : null);
      const href = parentLink ? parentLink.getAttribute('href') : null;
      const newTitle = getNewTitle(alt, href || (window.location.pathname.includes('/products/') ? window.location.pathname : null));
      if (newTitle) {
        if (alt && alt.trim() !== newTitle) {
          img.setAttribute('alt', newTitle);
        }
        // Remove native title attribute to prevent distracting browser hover tooltip boxes
        img.removeAttribute('title');
      }
    });
  }

  // Run on DOMContentLoaded and immediately
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', replaceTitles);
  } else {
    replaceTitles();
  }

  // Debounced & Throttled MutationObserver for AJAX collections, infinite scroll, quick view modal, cart drawer
  let mutationTimeout = null;
  let isUpdating = false;

  const debouncedReplaceTitles = () => {
    if (isUpdating) return;
    clearTimeout(mutationTimeout);
    mutationTimeout = setTimeout(() => {
      isUpdating = true;
      replaceTitles();
      isUpdating = false;
    }, 150);
  };

  const observer = new MutationObserver((mutations) => {
    // Only trigger if added nodes contain potential titles or relevant containers
    let shouldUpdate = false;
    for (let i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length > 0) {
        shouldUpdate = true;
        break;
      }
    }
    if (shouldUpdate) {
      debouncedReplaceTitles();
    }
  });

  const targetNode = document.body || document.documentElement;
  if (targetNode) {
    observer.observe(targetNode, {
      childList: true,
      subtree: true
    });
  }

  // ===================================================================
  // BULLETPROOF INACTIVE TAB TITLE ALTERNATOR (Option 1)
  // Seamlessly cycles "✨ Made for you" <-> "❤️ Looks stunning!" without breaks
  // ===================================================================
  let tabSwitchInterval = null;
  const awayTitles = ['✨ Made for you', '❤️ Looks stunning!'];
  let awayIndex = 0;

  function handleVisibilityChange() {
    if (document.hidden) {
      isTabInactive = true;
      // Capture the current clean title if not already an away message
      if (!document.title.includes('✨') && !document.title.includes('❤️')) {
        savedActiveTitle = document.title;
      }

      // Step 1: Immediately show the first message
      document.title = awayTitles[0];
      awayIndex = 1;

      // Step 2: Clear any running timer and start the seamless 3.5s alternator
      clearInterval(tabSwitchInterval);
      tabSwitchInterval = setInterval(function() {
        if (!document.hidden) {
          clearInterval(tabSwitchInterval);
          tabSwitchInterval = null;
          isTabInactive = false;
          if (savedActiveTitle) document.title = savedActiveTitle;
          return;
        }
        document.title = awayTitles[awayIndex];
        awayIndex = (awayIndex + 1) % awayTitles.length;
      }, 3500);

    } else {
      // Returned to tab: Immediately stop cycle and restore clean title
      isTabInactive = false;
      clearInterval(tabSwitchInterval);
      tabSwitchInterval = null;
      if (savedActiveTitle) {
        document.title = savedActiveTitle;
      }
    }
  }

  document.addEventListener('visibilitychange', handleVisibilityChange, false);
  window.addEventListener('blur', function() {
    if (document.hidden) handleVisibilityChange();
  }, false);
  window.addEventListener('focus', function() {
    handleVisibilityChange();
  }, false);
})();


